import { useEffect, useState } from 'react';
import { Search, Bell } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { CommandPalette } from '../atlas/CommandPalette';
import { NotificationCenter } from '../atlas/NotificationCenter';
import { useNotifications } from '../../hooks/useNotifications';

export function Header() {
  const [paletteOpen, setPaletteOpen] = useState(false);
  const [notifOpen, setNotifOpen] = useState(false);
  const { data: notifData } = useNotifications();
  const unread = notifData?.unreadCount ?? 0;

  useEffect(() => {
    function onKey(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'k') {
        e.preventDefault();
        setPaletteOpen(true);
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  return (
    <>
      <header className="h-14 border-b border-border bg-surface flex items-center px-4 gap-3">
        <div className="flex-1 max-w-md">
          <button
            type="button"
            onClick={() => setPaletteOpen(true)}
            aria-label="Buscar (⌘K)"
            className="w-full flex items-center gap-2 px-3 py-1.5 rounded-md border border-border text-ink-tertiary text-sm bg-canvas hover:text-ink-primary hover:border-border-strong transition-colors"
          >
            <Search size={16} />
            <span>Buscar (⌘K)</span>
          </button>
        </div>

        <div className="ml-auto flex items-center gap-1">
          <button
            type="button"
            onClick={() => setNotifOpen(true)}
            aria-label="Notificações"
            className="relative inline-flex items-center justify-center w-9 h-9 rounded-md text-ink-tertiary hover:text-ink-primary hover:bg-subtle transition-colors"
          >
            <Bell size={18} />
            {unread > 0 && (
              <span className="absolute top-1 right-1 bg-danger text-danger-contrast text-[10px] font-medium rounded-full min-w-[16px] h-4 px-1 flex items-center justify-center">
                {unread > 9 ? '9+' : unread}
              </span>
            )}
          </button>
          <ThemeToggle />
        </div>
      </header>

      <CommandPalette open={paletteOpen} onClose={() => setPaletteOpen(false)} />
      <NotificationCenter open={notifOpen} onClose={() => setNotifOpen(false)} />
    </>
  );
}
